import React, { useState } from 'react';
import '../styles/onboarding.css';

const STEPS = [
  {
    title: 'Welcome! Your decks are ready.',
    body: 'Every built-in stimulus deck is already here — Animals, Food, Colors, Actions, and more. Tap any deck to launch a session right now.',
    img: '/onboarding/dashboard.png',
    imgAlt: 'Dashboard showing all stimulus decks',
    tip: null,
  },
  {
    title: 'Pick your targets and settings.',
    body: 'Choose which cards to teach, how many choices appear per trial, and whether to use distractors. Everything is configurable before each session.',
    img: '/onboarding/session-setup.png',
    imgAlt: 'Session setup wizard showing target card selection',
    tip: null,
  },
  {
    title: 'Run the session — cards on screen.',
    body: 'The student taps the correct card. Results are tracked live in the side panel and auto-saved the moment the session ends.',
    img: '/onboarding/trial.png',
    imgAlt: 'Active trial showing photo cards and live result panel',
    tip: '→ Double-tap any card during a session to see all its photo variations.',
  },
  {
    title: 'Create any deck you can imagine.',
    body: 'Name it, pick an icon, then add cards using your device camera, photos from your photo library, or by searching the web. Any topic. Any photos. Fully yours.',
    img: '/onboarding/create-deck.png',
    imgAlt: 'Create deck wizard showing name, icon, and photo options',
    tip: '→ Tap "Create New Set" in the sidebar anytime to build a custom deck.',
  },
];

export const OnboardingModal = ({ onDone }) => {
  const [step, setStep] = useState(0);
  const isLast = step === STEPS.length - 1;
  const s = STEPS[step];

  const next = () => {
    if (isLast) { onDone(); return; }
    setStep(s => s + 1);
  };

  return (
    <div className="onb-overlay">
      <div className="onb-modal">
        {/* Screenshot */}
        <div className="onb-screenshot-wrap">
          <img
            key={step}
            src={s.img}
            alt={s.imgAlt}
            className="onb-screenshot"
          />
          <div className="onb-step-badge">{step + 1} / {STEPS.length}</div>
        </div>

        {/* Progress dots */}
        <div className="onb-progress">
          {STEPS.map((_, i) => (
            <div
              key={i}
              className={`onb-dot${i === step ? ' onb-dot--active' : i < step ? ' onb-dot--done' : ''}`}
              onClick={() => setStep(i)}
            />
          ))}
        </div>

        {/* Text */}
        <div className="onb-body">
          <h2 className="onb-title">{s.title}</h2>
          <p className="onb-text">{s.body}</p>
          {s.tip && <p className="onb-tip">{s.tip}</p>}
        </div>

        {/* Footer */}
        <div className="onb-footer">
          <div className="onb-btn-row">
            {step > 0 && (
              <button className="onb-back-btn" onClick={() => setStep(s => s - 1)} type="button">
                ← Back
              </button>
            )}
            <button className="onb-next-btn" onClick={next} type="button">
              {isLast ? 'Start using the app →' : 'Next →'}
            </button>
          </div>
          {!isLast && (
            <button className="onb-skip" onClick={onDone} type="button">
              Skip tutorial
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
